"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcRentalFormServicesTable = class UcRentalFormServicesTable extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    onMeterSelected(...args) {
        const { col, option, row, value } = args[0].data;
        if (value && value.unit) {
            row.billing_unit = value.unit;
        }
    }
    editable;
    onEditable(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("editable");
    }
    rentalId;
    onRental_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("rentalId");
    }
    items;
    async $$load_items() {
        return this.$fn.fetch('list_rental_service', { parameters: { rental_id: this.rentalId } })
            .then(d => _.orderBy(d, ['id']));
    }
    units;
    async $$load_units() {
        return this.$fn.fetch('list_unit').then(d => _.orderBy(d, [p => p.symbol.toLowerCase()]));
    }
    ux;
    b_7315092382398562_columns;
    async $$load_b_7315092382398562_columns() {
        return [{
                name: "locked",
                type: "lock",
            },
            {
                name: "inactive",
                header: this.$fn.gettext("Inactive"),
                width: "30px",
                textAlign: "center",
                formatter: {
                    name: "checkbox",
                },
                editor: {
                    name: "checkbox",
                },
            },
            {
                name: "valid_from",
                type: "date",
                header: this.$fn.gettext("Valid From"),
                width: "120px",
            },
            {
                name: "valid_to",
                type: "date",
                header: this.$fn.gettext("Valid To"),
                width: "120px",
            },
            {
                name: "service",
                type: "select2",
                header: this.$fn.gettext("Service"),
                width: "250px",
                required: true,
                path: "name",
                bindObject: true,
                textField: "name",
                options: this.$fn.searchDataSource('suggest_product', { product_types: ['service'] }),
            },
            {
                name: "meter",
                type: "select2",
                header: this.$fn.gettext("Meter"),
                width: "250px",
                path: "serial_number",
                bindObject: true,
                textField: "serial_number",
                options: this.$fn.searchDataSource('suggest_meter', { t: 'rentalService' }),
                formatter: {
                    name: "template",
                    value: "<b-link :to=\"{\n\
  name: 'app.meter',\n\
  params: { id: row.meter.id }\n\
}\">{{ row.meter.serial_number }}</b-link>\n\
",
                },
            },
            {
                name: "billing_unit",
                type: "select2",
                header: this.$fn.gettext("Billing Unit"),
                width: "120px",
                path: "billing_unit",
                valueField: "symbol",
                textField: "symbol",
                required: true,
                options: this.units,
            },
            {
                name: "meter_factor",
                type: "number",
                header: this.$fn.gettext("Factor"),
                width: "100px",
            },
            {
                name: "notes",
                header: this.$fn.gettext("Notes"),
                width: "320px",
            },
        ];
    }
    dataMembers = ['items', 'units', 'ux', 'b_7315092382398562_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                items: null,
                units: null,
                ux: {
                    initialLoadSpinner: true,
                },
                b_7315092382398562_columns: null,
            },
        };
    }
    async act_7315092382398562_script_9544_getActionArgs_value($event) {
        $event.data.waitFor(this.$fn.crud('rental_service').upsert({
            ...$event.data.row,
            asset_id: $event.data.row.asset_id,
            service_id: $event.data.row.service.id,
            meter_id: _.get($event.data.row, 'meter.id'),
        }));
    }
    async act_7315092382398562_script_9544_getActionArgs($event) {
        return {
            value: () => this.act_7315092382398562_script_9544_getActionArgs_value($event),
        };
    }
    async evh_7315092382398562_save(event, scope) {
        return await this.actions.evh_7315092382398562_save.executeFromDOM(this, event, scope);
    }
    async act_7315092382398562_script_9546_getActionArgs_value($event) {
        $event.data.waitFor(this.$fn.crud('rental_service').delete($event.data.row));
    }
    async act_7315092382398562_script_9546_getActionArgs($event) {
        return {
            value: () => this.act_7315092382398562_script_9546_getActionArgs_value($event),
        };
    }
    async evh_7315092382398562_delete(event, scope) {
        return await this.actions.evh_7315092382398562_delete.executeFromDOM(this, event, scope);
    }
    async act_7315092382398562_script_9548_getActionArgs_value($event) {
        this.onMeterSelected($event);
    }
    async act_7315092382398562_script_9548_getActionArgs($event) {
        return {
            value: () => this.act_7315092382398562_script_9548_getActionArgs_value($event),
        };
    }
    async evh_7315092382398562_meterSelected(event, scope) {
        return await this.actions.evh_7315092382398562_meterSelected.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_script_9544 = new core_1.actions.ScriptAction({
            actionArgs: this.act_7315092382398562_script_9544_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_save_9543 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_script_9544,
            event: "save",
            displayName: "script",
        });
        const evh_7315092382398562_save = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_save_9543],
        });
        const act_7315092382398562_script_9546 = new core_1.actions.ScriptAction({
            actionArgs: this.act_7315092382398562_script_9546_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_delete_9545 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_script_9546,
            event: "delete",
            displayName: "script",
        });
        const evh_7315092382398562_delete = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_delete_9545],
        });
        const act_7315092382398562_script_9548 = new core_1.actions.ScriptAction({
            actionArgs: this.act_7315092382398562_script_9548_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_meterSelected_9547 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_script_9548,
            event: "meter:selected",
            displayName: "script",
        });
        const evh_7315092382398562_meterSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_meterSelected_9547],
        });
        return {
            act_7315092382398562_script_9544,
            evh_7315092382398562_save_9543,
            evh_7315092382398562_save,
            act_7315092382398562_script_9546,
            evh_7315092382398562_delete_9545,
            evh_7315092382398562_delete,
            act_7315092382398562_script_9548,
            evh_7315092382398562_meterSelected_9547,
            evh_7315092382398562_meterSelected,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
        default: true,
    }),
    __metadata("design:type", Boolean)
], UcRentalFormServicesTable.prototype, "editable", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('editable'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcRentalFormServicesTable.prototype, "onEditable", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], UcRentalFormServicesTable.prototype, "rentalId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('rentalId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcRentalFormServicesTable.prototype, "onRental_id", null);
UcRentalFormServicesTable = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcRentalFormServicesTable);
exports.default = UcRentalFormServicesTable;
vue_property_decorator_1.Vue.component("UcRentalFormServicesTable", UcRentalFormServicesTable);
